import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {SecondaryButton} from 'Components/Button';
import {RenderWYSIWYG} from 'Components/Form';

import {translation} from 'Services/TranslationHelpers';
import {getRecordValue} from 'Services/CmsHelpers';
import {asset} from "Services/BaseHelpers";

export default class SpeakerModal extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {onClose, speaker} = this.props;

        let photo = getRecordValue(speaker, 'photo');
        let bio = getRecordValue(speaker, 'bio');

        return (
            <Modal>
                <ModalHeader onClose={onClose}>
                    {getRecordValue(speaker, 'first_name')} {getRecordValue(speaker, 'last_name')}
                </ModalHeader>

                <ModalBody>
                    <img
                        src={photo?.url}
                        className="w-2/3 w-1/3 mx-auto px-4"
                    />

                    {bio &&
                        <div className="mt-6">
                            <RenderWYSIWYG
                                content={bio}
                            />
                        </div>
                    }
                </ModalBody>

                <ModalFooter alignment="center">
                    <SecondaryButton 
                        text={translation('misc', 'close')} 
                        onClick={onClose}
                    />
                </ModalFooter>
            </Modal>
        )
    }
};
